// Converts a File or Blob to a base64 string (without the data URL prefix)
export function fileToBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            // Remove the data URL prefix to get only the base64 string
            const base64String = reader.result.split(',')[1];
            resolve(base64String);
        };
        reader.onerror = error => reject(error);
    });
}
function urlBase64Decode(str) {
    if (!str) {
        throw new Error('Illegal base64url string!');
    }
    let output = str.replace(/[-_]/g, match => match === '-' ? '+' : '/');
    switch (output.length % 4) {
        case 0:
            break;
        case 2:
            output += '==';
            break;
        case 3:
            output += '=';
            break;
        default:
            throw new Error('Illegal base64url string!');
    }
    return window.atob(output);
}

export { urlBase64Decode };